import { __awaiter } from "tslib";
import { BootstrapError } from './bootstrapError';
import { appendSvgSprites, createSvgSpritesConainer } from './utils';
const loadScript = (url) => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';
    script.async = true;
    script.onload = () => resolve(null);
    script.onerror = () => {
        reject(new BootstrapError(`Script load error for: ${url}`));
    };
    document.body.appendChild(script);
});
const loadSvgSprite = (url) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetch(url);
        const content = yield response.text();
        return content;
        // вставляем svg в начало body
    }
    catch (e) {
        return new BootstrapError(`unable to load engine icons: ${url}`);
    }
});
const addExternalResources = (options) => __awaiter(void 0, void 0, void 0, function* () {
    const { scripts = [], svgs = [] } = options;
    // Параллельно загружаем все скрипты
    if (scripts.length > 0) {
        yield Promise.all(scripts.map((scriptUrl) => __awaiter(void 0, void 0, void 0, function* () {
            yield loadScript(scriptUrl);
        })));
    }
    if (svgs.length > 0) {
        const svgsLoadResults = yield Promise.all(svgs.map((svgUrl) => __awaiter(void 0, void 0, void 0, function* () {
            return yield loadSvgSprite(svgUrl);
        })));
        appendSvgSprites(svgsLoadResults.filter(result => !(result instanceof BootstrapError)));
        const svgsLoadErrors = svgsLoadResults.filter(result => result instanceof BootstrapError);
        if (svgsLoadErrors.length > 0) {
            throw new BootstrapError(svgsLoadErrors.map((error) => error.message).join('\n'));
        }
    }
});
// Функция инициализации приложения
export const bootstrap = (config) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (document.body.querySelector('svg#svgSpritesRoot')) {
        return;
    }
    createSvgSpritesConainer();
    try {
        yield addExternalResources({
            scripts: [
                ...new Set([
                    ...((_b = (_a = config.global.additionalResources) === null || _a === void 0 ? void 0 : _a.scripts) !== null && _b !== void 0 ? _b : []),
                    ...((_d = (_c = config.global.additionalResources) === null || _c === void 0 ? void 0 : _c.extraScripts) !== null && _d !== void 0 ? _d : [])
                ])
            ]
        });
        console.info('All external scripts were loaded successfully.');
    }
    catch (BootstrapError) {
        console.error(BootstrapError);
    }
    try {
        yield addExternalResources({
            svgs: [
                ...new Set([
                    ...((_f = (_e = config.global.additionalResources) === null || _e === void 0 ? void 0 : _e.svgs) !== null && _f !== void 0 ? _f : []),
                    ...((_h = (_g = config.global.additionalResources) === null || _g === void 0 ? void 0 : _g.extraSvgs) !== null && _h !== void 0 ? _h : [])
                ])
            ]
        });
        console.info('All external svg sprites were loaded successfully.');
    }
    catch (BootstrapError) {
        console.error(BootstrapError);
    }
});
